import React, { Suspense } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { dashboardRoutes } from '../../domains/Dashboard/routes';
import { identityEventLogsRoutes } from '../../domains/IdentityEventLogs/routes';
import { mappingsRoutes } from '../../domains/Mappings/routes';
import { organizationRoutes } from '../../domains/Organizations/routes';
import { pageStatesRoutes } from '../../domains/PageStates/routes';
import { policyManagerRoutes } from '../../domains/PolicyManager/routes';
import { profileRoute } from '../../domains/Profile/routes';
import { usersRoutes } from '../../domains/Users/routes';
import NoPermission from '../NoPermission/NoPermission';

const PageRoutes = () => {
  const { search } = useLocation();

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<Navigate to={`organizations${search}`} />} />
        <Route
          path="/account-metrics"
          element={<Navigate to={`/organizations${search}`} />}
        />
        <Route
          path="/dashboard"
          element={<Navigate to={`/organizations${search}`} />}
        />
        {dashboardRoutes}
        {organizationRoutes}
        {policyManagerRoutes}
        {mappingsRoutes}
        {usersRoutes}
        {identityEventLogsRoutes}
        {pageStatesRoutes}
        {profileRoute}
        <Route path="/no-access" element={<NoPermission />} />
        <Route path="*" element={<Navigate to="/404" />} />
      </Routes>
    </Suspense>
  );
};

export default PageRoutes;
